import styled from 'styled-components'
import { Link } from 'react-router-dom'
import AnnotationReverseList from '../AnnotationReverseList'
import Comment from '../Comment'
import EditCommentInput from '../EditCommentInput'
import { Separator } from '../CommentNewSeparator/CommentNewSeparator.styles'

export const AnnotationComment = styled(Comment)`
  &[data-first-comment='true'] {
    margin: 4px 0px; /* stylelint-disable-line scales/space */

    :hover,
    :focus-within {
      background: none;
    }

    &${EditCommentInput} {
      margin: 8px 0px;
    }
  }
`

export const AnnotationCommentsWrapper = styled(AnnotationReverseList).attrs({
  'data-testid': 'comment-list',
})``

export const ViewLatestMessage = styled.p`
  margin: 0;
  padding: 12px 8px; /* stylelint-disable-line scales/space */
  text-align: center;

  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  font-size: 0.75rem; /* 12px */
`

export const ViewLatestLink = styled(Link)`
  color: ${({ theme }) => theme.colors.sketch.A};
  font-size: inherit;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }
`

export const AnnotationFirstCommentSeparator = styled.div`
  /* 1000vh is used like a infinite measure so we can set the background bellow all the response items */
  clip-path: inset(0px 0px -1000vh 0px);
  border-top: 1px solid ${({ theme }) => theme.colors.shadow.inner};

  margin: 4px -8px 0;
  padding-top: 8px;

  ::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0 8px;
    height: 1000vh;
    background: ${({ theme }) =>
      theme.colors.ui.annotations.commentListBackground};
  }

  ${Separator} + & {
    /* Make the Separator closer to the Background separator */
    margin-top: -5px; /* stylelint-disable-line scales/space */
    border-top: none;
  }
`
